import { useQuery } from '@tanstack/react-query';
import axiosInstanceAnalyze from '@/axios/AxiosInstanceAnalyze';

interface NotableVisual {
  url: string;
  type: string;
  caption: string;
  questionId?: string;
  respondentIndex?: number;
  conversationId?: string;
}

export function useGetNotableVisuals(projectId?: string, filterId?: string | null) {
  return useQuery({
    queryKey: ['notableVisuals', projectId, filterId],
    queryFn: async () => {
      const params = filterId ? `?filter_id=${filterId}` : '';
      const { data } = await axiosInstanceAnalyze.get<NotableVisual[]>(
        `/analyzer/results/${projectId}/notable-visuals${params}`,
      );
      return data;
    },
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000,
  });
}
